import {getCookies} from '../../../utils/getters/getCookies';
import {initProjectMap} from './initProjectMap';

export const initProjectCard = () => {
	const projectCard = document.querySelector( 'section.project-card' );

	if ( !projectCard )
	{
		return;
	}

	const lineSlider = projectCard.querySelector( 'div.line-slider' );
	const currentCookies = getCookies();

	const hideTip = () => {
		const expires = new Date( 3000, 0 );

		lineSlider.classList.remove( 'will-show-animation' );
		document.cookie = `grab_tip=grab_tip; expires=${expires.toGMTString()}; path=/`;
	};

	if ( currentCookies['grab_tip'] )
	{
		lineSlider.classList.remove( 'will-show-animation' );
	}
	else
	{
		setTimeout( () => {
			hideTip();
		}, 15000 );
	}

	const slidesContainer = lineSlider.querySelector( 'ul.line' );
	const headingStation = slidesContainer.querySelector( 'li.current' );
	const previousStation = headingStation.previousElementSibling;
	const lastStation = slidesContainer.querySelector( 'li:last-child' );
	const mapContainer = projectCard.querySelector( 'div.map' );
	const data = mapContainer.getAttribute('data-json');

	if ( previousStation )
	{
		previousStation.classList.add( 'prev' );
	}

	let lineSliderRect = lineSlider.getBoundingClientRect();
	let headingStationRect = headingStation.getBoundingClientRect();
	const initialPosition = Math.round( lineSliderRect.x - headingStationRect.x );
	let currentPosition = initialPosition;
	let currentDirection = null;
	let href = null;
	let timeStamp = 0;
	let touch;

	slidesContainer.style.transform = `matrix( 1, 0, 0, 1, ${currentPosition}, 0 )`;

	const getXCoordinate = ( evt ) => typeof evt.pageX === 'number' ? evt.pageX : evt.touches[0].pageX;
	const getYCoordinate = ( evt ) => typeof evt.pageY === 'number' ? evt.pageY : evt.touches[0].pageY;

	const handleDragStart = ( evt ) => {
		if (
			( evt.timeStamp === timeStamp )
		||	( evt.button && evt.button > 0 )
		||	( evt.touches && evt.touches.length !== 1 )
		||	slidesContainer.classList.contains( 'sliding' )
		)
		{
			return;
		}

		if ( evt.type === 'mousedown' )
		{
			evt.preventDefault();
		}

		timeStamp = evt.timeStamp;
		slidesContainer.classList.add( 'grabbing' );

		touch = {
			position: currentPosition,
			started: true,
			xCoordinate: getXCoordinate( evt ),
			yCoordinate: getYCoordinate( evt ),
		};

		document.addEventListener( 'mousemove', handleDragMove );
		document.addEventListener( 'touchmove', handleDragMove, { passive: false } );
		document.addEventListener( 'mouseup', handleDragEnd );
		document.addEventListener( 'touchcancel', handleDragEnd );
		document.addEventListener( 'touchend', handleDragEnd );
		document.addEventListener( 'touchleave', handleDragEnd );
	};

	const handleDragMove = ( evt ) => {
		if ( !touch.started && !slidesContainer.classList.contains( 'sliding' ) )
		{
			return;
		}
		
		hideTip();
		
		const xCoordinate = getXCoordinate( evt );
		const yCoordinate = getYCoordinate( evt );

		if ( touch.started )
		{
			touch.started = false;
			
			if ( Math.abs( touch.xCoordinate - xCoordinate ) >= Math.abs( touch.yCoordinate - yCoordinate ) )
			{
				slidesContainer.classList.add( 'sliding' );
			}
			else
			{
				return;
			}
		}

		if ( evt.cancelable )
		{
			evt.preventDefault();
		}
		
		const direction = touch.xCoordinate < xCoordinate ? 1 : -1;
		const diff = Math.abs( touch.xCoordinate - xCoordinate );
		const lastStationRect = lastStation.getBoundingClientRect();

		lineSliderRect = lineSlider.getBoundingClientRect();
		touch.position = currentPosition + diff * direction;

		if ( touch.position > 0 || lastStationRect.x + lastStationRect.width < lineSliderRect.x + lineSliderRect.width && direction < 0 && touch.position < initialPosition )
		{
			touch.position = currentPosition;
		}

		slidesContainer.style.transform = `matrix( 1, 0, 0, 1, ${touch.position}, 0 )`;
		currentDirection = direction;
		currentPosition = touch.position;
		touch.xCoordinate = xCoordinate;
	};

	const handleDragEnd = ( evt ) => {
		if ( touch.started )
		{
			if ( href )
			{
				location.href = href;
			}
		}

		touch = null;
		slidesContainer.classList.remove( 'sliding', 'grabbing' );
		document.removeEventListener( 'mousemove', handleDragMove );
		document.removeEventListener( 'touchmove', handleDragMove );
		document.removeEventListener( 'mouseleave', handleDragEnd );
		document.removeEventListener( 'mouseout', handleDragEnd );
		document.removeEventListener( 'mouseup', handleDragEnd );
		document.removeEventListener( 'touchcancel', handleDragEnd );
		document.removeEventListener( 'touchend', handleDragEnd );
		document.removeEventListener( 'touchleave', handleDragEnd );
	};

	lineSlider.addEventListener( 'mousedown', handleDragStart );
	lineSlider.addEventListener( 'touchstart', handleDragStart, {passive: true} );

	initProjectMap( mapContainer, data, projectCard );
};
